import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Field
name: Field
category: React - Bulma
---

A `Field` component based on Bulma `.field`. This is to be used to wrap inputs
inside forms.

If you're trying to build a form, take a look at the different field components.
Using those will help ensure consistency.

See [Bulma Documentation](http://bulma.io/documentation/form/general/#form-field) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

```html_example
  <form>
    <Field>
      <Label htmlFor="example">Input name</Label>
      <Control>
        <Input name="example" type="text" onChange={onChangeHandler} />
      </Control>
    </Field>
  </form>
```
*/
function Field(props) {
  const {
    className, isGrouped, hasAddons, children, ...rest
  } = props

  const classes = [
    'field',
    className || '',
    isGrouped ? 'is-grouped' : '',
    hasAddons ? 'has-addons' : '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

Field.defaultProps = {
  isGrouped: false,
  hasAddons: false,
}

Field.propTypes = {
  // When grouping buttons together..
  isGrouped: PropTypes.bool,
  // When the field contains add-ons.
  hasAddons: PropTypes.bool,
}

export default Field
